import React from 'react';
import LocationTemplate from './LocationTemplate';

const HookertonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Hookerton"
      stateName="North Carolina"
      countyName="Greene"
      zipCodes={["28538"]}
      latitude={35.4274}
      longitude={-77.5839}
      population={409}
      historicalFact="Established in 1806 on Contentnea Creek, named after early settler William Hooker."
      nearbyTowns={[
        "Snow Hill, NC",
        "Kinston, NC",
        "Farmville, NC",
        "Winterville, NC",
        "Stantonsburg, NC",
        "Ayden, NC",
        "Walstonburg, NC",
        "Grifton, NC"
      ]}
    />
  );
};

export default HookertonPage;